import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IAnswerResult, IQuizState } from ".";

export type IQuizAnswerResponse = IAnswerResult;

export const quizAnswer = createAsyncThunk<IQuizAnswerResponse, number>(
    'quiz.quizAnswer',
    async (answerIndex: number) => await api.quizzes.answer(answerIndex)
);

const quizAnswerHandler = (builder: ActionReducerMapBuilder<IQuizState>) => {
    builder
        .addCase(quizAnswer.pending, (state: IQuizState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(quizAnswer.fulfilled, (state: IQuizState, action: PayloadAction<IQuizAnswerResponse>) => {
            if (!action.payload)
                return;

            state.loading = false;            
            state.answerResult = action.payload;
        })
        .addCase(quizAnswer.rejected, (state: IQuizState) => {
            state.loading = false;
            state.error = 'Unable to send quiz answer';
        });
};

export default quizAnswerHandler;